import styled from 'styled-components';
export var InputContainer = styled.div.withConfig({
  displayName: "Input__InputContainer",
  componentId: "sc-eoxsre-0"
})(["position:relative;margin-bottom:16px;input{display:block;width:100%;padding:4px 6px;border:1px solid ", ";border-radius:4px;font-size:14px;line-height:26px;}svg{position:absolute;top:6px;right:6px;}"], function (_ref) {
  var theme = _ref.theme;
  return theme.colors.ui;
});